
import Vue from "vue";

export default Vue.extend({
    name: "TitledSubsection",
    props: {
        title: {
            type: String,
            required: false,
            default: "",
        },
    },
});
